import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types, Creators } = createActions({
	downloadFile: ['arquivo', 'callback'],
	downloadFileReducer: ['arquivo'],
});

export const INITIAL_STATE_VALUES = {
	arquivo: '',
};

const INITIAL_STATE = Immutable(Object.assign({}, INITIAL_STATE_VALUES));

const downloadFileReducer = (state = INITIAL_STATE, action) => state.merge({
	arquivo: { ...action.arquivo },
});

export default createReducer(INITIAL_STATE, {
	[Types.DOWNLOAD_FILE_REDUCER]: downloadFileReducer,
});
